import { Box, Typography } from "@mui/material";
import React from "react";
import TestimonialCard from "../TestimonialCard";
import type { Testimonial } from "../../content/roleFaqsContent";

interface TestimonialsSectionProps {
  testimonials: Testimonial[];
  id?: string;
}

const TestimonialsSection: React.FC<TestimonialsSectionProps> = ({
  testimonials,
  id = "testimonials",
}) => {
  if (!testimonials?.length) return null;

  return (
    <Box id={id} component="section" sx={{ mb: 6 }}>
      <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: "bold" }}>
        Testimonials
      </Typography>
      {testimonials.map((t, i) => (
        <Box key={i} sx={{ mb: 2 }}>
          <TestimonialCard testimonial={t} sx={{ mb: 0 }} />
        </Box>
      ))}
    </Box>
  );
};

export default TestimonialsSection;
